







import { Component, Prop, Vue } from 'vue-property-decorator'
import { Room } from '@/class/room'
import Checkbox from '@/components/Utils/form/checkbox/Checkbox.vue'
import HeadlineBorder from '@/components/Utils/headline/HeadlineBorder.vue'

@Component({
  components: {
    Checkbox,
    HeadlineBorder
  }
})
export default class GallarySettings extends Vue {
  @Prop() room!: Room;

  updateRoom () {
    this.room.updateRoom()
  }
}
